import request from '@/CommonDP/utils/request';
import qs from 'qs';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from '@/CommonDP/utils/globalParams.js';
// 整合模型
export default {
  queryPrj(params) {
    return request.get(`/project/getProjectsByUserId`, { params });
  },
  // 保存用户访问历史
  savePubUserVisit(params) {
    return request.post(`/pubUserVisitHistory/savePubUserVisit`, params);
  },
  // 查询用户访问记录
  getHistoryList(params) {
    return request.get(`/pubUserVisitHistory/prj/list`, { params });
  },
  downloadfolder(params1) {
    return request({
      responseType: 'blob',
      url: '/download/folder',
      method: 'post',
      data: params1
    });
  },
  downloadSharefolder(shareToken, params) {
    return request({
      responseType: 'blob',
      url: '/doc/shareNew/folder/download?shareToken=' + shareToken,
      method: 'post',
      data: params
    });
  },
  lightuploadLightFile(params) {
    return request.post(`/light/uploadLightFile`, params);
  },
  integrationModel(params) {
    return request.post(`/integrationModel/add`, params);
  },
  getQueryList(prjID) {
    return request
      .get(`/integrationModel/queryList?prjId=${prjID}`)
      .then((res) => res);
  },
  batchDelete(params) {
    return request.post(`/integrationModel/batchDelete`, params);
  },
  // 分页查询整合模型记录
  queryIntegrationModelLogPage(params) {
    return request.get(
      `/integrationModel/queryIntegrationModelLogPage?${qs.stringify(
        params
      )}`
    );
  },
  // 添加整合模型记录
  addIntegrationModelLog(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/integrationModel/addIntegrationModelLog");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post(
      `/integrationModel/addIntegrationModelLog`,
      params
    );
  },
  // 批量删除整合模型记录
  batchIntegrationModelLog(params) {
    return request.post(
      `/integrationModel/batchIntegrationModelLog`,
      params
    );
  }
};
